import { FC, useCallback, useState } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { SendAction } from './send-action';

interface InputBoxProps {
  placeholder?: string;
  onSend?: (value: string) => void;
}

export const InputBox: FC<InputBoxProps> = ({ placeholder, onSend }) => {
  const [value, setValue] = useState('');
  const { t } = useTranslation('aiOnboarding');

  const handleSend = useCallback(() => {
    if (value.trim() && onSend) {
      onSend(value);
      setValue('');
    }
  }, [value, onSend]);

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSend();
    }
  };

  const isDisabled = !value.trim();

  return (
    <div css={styles.container}>
      <input
        type='text'
        placeholder={placeholder || t('Ask me anything...')}
        css={styles.input}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyUp={handleKeyPress}
      />
      <SendAction onClick={handleSend} disabled={isDisabled} />
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    border: 1px solid ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.large};
    padding: ${theme.spacing(1)};
    gap: ${theme.spacing(1)};
  `,
  input: css`
    border: none;
    outline: none;
    flex: 1;
    padding: ${theme.spacing(1)};
    background-color: transparent;
  `,
};
